<template>
    <div
        class="layout invertible"
        :class="{ invert: $store.getters['theme/isDarkTheme'] }"
    >
        <nav
            class="navbar is-sticky-top has-shadow"
            role="navigation"
            aria-label="main navigation"
        >
            <div class="navbar-brand">
                <router-link to="/" class="navbar-item" title="Home">
                    <img
                        class="logo"
                        alt="logo"
                        src="../assets/icons/LogoTribunal.png"
                        width="140"
                        height="70"
                    />
                </router-link>
            </div>

            <div
                id="layoutMenu"
                class="navbar-menu"
                :class="{ 'is-active': layoutMenuActive }"
            >
                <div class="navbar-end">
                    <p
                        v-if="isLogged && (isSupervisor || isAuditor)"
                        class="navbar-item is-pointer has-text-primary mr-2"
                        @click="goRegister"
                    >
                        <img
                            src="../assets/icons/callRegister.svg"
                            width="30"
                            height="25"
                        />
                    </p>
                    <!-- <p
                        v-if="isLogged"
                        class="navbar-item is-pointer has-text-primary mr-2"
                        @click="goDashboard"
                    >
                        <Icon family="fal" name="fa-chart-line" />
                    </p> -->
                    <p
                        v-if="isLogged && isSupervisor"
                        class="navbar-item is-pointer has-text-primary mr-2"
                        @click="goReports"
                    >
                        <Icon family="fas" name="fa-file-chart-line" />
                    </p>
                    <p
                        v-if="showLogin"
                        class="navbar-item is-pointer has-text-primary mr-2"
                        @click="openBrowserCompatibility"
                    >
                        <Icon family="fal" name="fa-globe" />
                    </p>

                    <LanguageSelector v-if="showLogin" />

                    <Sso v-if="showLogin" />
                </div>
            </div>
        </nav>

        <BrowserCompatibility />

        <div id="main-container">
            <main class="main-content">
                <slot />
            </main>
        </div>

        <article
            class="message is-danger"
            id="update-message"
            v-if="updateExists"
        >
            <div class="message-body">
                {{ $t("update.message") }}
                <br />
                <button class="button" @click="refreshApp">
                    {{ $t("update.actualizar") }}
                </button>
            </div>
        </article>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import LanguageSelector from "../components/Language.vue";
import BrowserCompatibility from "@/components/BrowserCompatibility.vue";
import Sso from "@/components/sso/Sso.vue";

export default {
    name: "LayoutDefault",
    components: {
        LanguageSelector,
        BrowserCompatibility,
        Sso,
    },
    data() {
        return {
            layoutMenuActive: false,

            refreshing: false,
            registration: null,
            updateExists: false,
        };
    },
    created() {
        document.addEventListener("swUpdated", this.showRefreshUI, {
            once: true,
        });

        navigator.serviceWorker.addEventListener("controllerchange", () => {
            if (this.refreshing) return;
            this.refreshing = true;
            window.console.log("reloading");
            window.location.reload();
        });
    },
    computed: {
        ...mapGetters("oidcStore", ["oidcUser", "oidcIsAuthenticated"]),
        userName() {
            return this.isLogged
                ? `${this.oidcUser.given_name} ${this.oidcUser.family_name}`
                : "";
        },
        isLogged() {
            return this.oidcIsAuthenticated;
        },
        showLogin() {
            return !this.oidcIsAuthenticated
                ? this.$route.name === "home"
                : true;
        },
        isSupervisor() {
            let roles = this.oidcUser.role;
            return roles.indexOf("Supervisor") > -1;
        },
        isAuditor() {
            let roles = this.oidcUser.role;
            return roles.indexOf("Auditor") > -1;
        },
    },
    methods: {
        ...mapActions("oidcStore", ["authenticateOidc", "signOutOidc"]),
        ...mapActions("browserCompatibility", ["open"]),
        openBrowserCompatibility() {
            this.open({ allowClose: true });
        },
        showRefreshUI(e) {
            this.registration = e.detail;
            this.updateExists = true;
        },
        refreshApp() {
            this.updateExists = false;
            if (!this.registration || !this.registration.waiting) {
                return;
            }
            this.registration.waiting.postMessage("skipWaiting");
        },
        goRegister() {
            this.$router.push({ name: "rooms" });
        },
        goDashboard() {
            this.$router.push({ name: "dashboard" });
        },
        goReports() {
            this.$router.push({ name: "reports" });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.sass";

.logo {
    max-height: 2.7rem;
}
.icon {
    font-size: 1.25rem;
    width: 2rem;
}

.layout {
    min-height: 100vh;
}

#main-container {
    position: relative;
    display: flex;
    flex-direction: row;
    flex: 1;
    min-height: calc(100vh - 3.75rem);

    & .sidebar-menu {
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        width: 16rem;
        padding: 1rem 0.75rem;
    }

    & main.main-content {
        position: relative;
        width: 100%;
    }
}

@media screen and (max-width: $navbar-breakpoint) {
    #main-container {
        display: block;
        min-height: initial;

        & .sidebar-menu {
            display: none;
        }

        & main.main-content {
            padding: 0rem;
            height: calc(100vh - 3.75rem);
        }
    }
}
</style>